import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { translate } from 'react-i18next';
import debounce from 'lodash/debounce';

import { getUsers, setFilters, setPagination } from 'users/actions';

import { getCompany, getPermissions } from 'auth/selectors';
import {
  getVisibleUsers,
  getFilters,
  getPagination,
  getIsLoading,
  getNeedFetch,
} from 'users/selectors';

import * as Common from 'common/components';
import * as Users from 'users/components';
import UserRowContainer from 'users/containers/UserRowContainer';

import UserRow from 'notifications_config/components/form/sections/NotificationConfigFormUserRow';
import UsersTable from 'notifications_config/components/form/sections/NotificationConfigFormUsersTable';

import UserToNotifyRow from 'notifications_config/components/form/sections/NotificationConfigFormUserToNotifyRow';
import UsersToNotifyTable from 'notifications_config/components/form/sections/NotificationConfigFormUsersToNotifyTable';

import { valueFromEvent } from 'lib/util';
import { toggleUser } from 'users/actions';
import { addGrowlError as error, addGrowlSuccess as success } from 'messages/actions';
import { t } from 'i18next/dist/commonjs';
import PropTypes from 'prop-types';

class UserListContainer extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };
  state = {
    columnSearch: [
      // Cambiar por redux
      { key: 'name', name: this.props.t('users.searchEditor.name'), search: true },
      { key: 'lastname', name: this.props.t('users.searchEditor.lastName'), search: true },
      { key: 'email', name: this.props.t('users.searchEditor.email'), search: true },
    ],
  };

  handleToggleSearch = (col) => {
    let columnsNuevo = this.state.columnSearch;
    let datos = columnsNuevo.find((column) => column.key == col);
    datos.search = !datos.search;
    this.setState({ columnSearch: columnsNuevo });
    let columnsSearch = [];
    columnsNuevo.forEach((e) => {
      if (e.search) {
        columnsSearch.push(e.key);
      }
    });
    this.props.setFilters({ columnSearch: columnsSearch }); // Agregado a Redux
  };
  componentWillMount = () => this.fetch(this.props.filters, this.props.pagination);

  componentWillReceiveProps = (nextProps) =>
    nextProps.needFetch && this.fetch(nextProps.filters, nextProps.pagination);

  fetch = (filters, pagination) =>
    this.props.getUsers(
      this.props.company.id,
      filters,
      pagination.limit,
      pagination.page,
      pagination.orderBy,
      pagination.order
    );

  fetchDebounced = debounce(this.fetch, 100);

  handleSubmit = () => this.fetch(this.props.filters, this.props.pagination);

  handleValueChange = (e) => this.props.setFilters(valueFromEvent(e));

  handleOrderChange = (orderBy, order) => this.props.setPagination({ orderBy, order });

  handleLimitChange = (limit) => this.props.setPagination({ limit });

  handlePageChange = (page) => this.props.setPagination({ page });

  handleToggle = (id) => {
    console.log(id);
    console.log(this.props.company);

    return this.props
      .toggleUser(this.props.company.id, id)
      .then(({ value }) => this.props.success(value.message))
      .catch((err) => this.props.error(err.message));
  };

  handleRemove = (id) => {
    console.log(id);
    console.log(this.props.company);

    return this.props
      .removeUser(this.props.company.id, id)
      .then(({ value }) => this.props.success(value.message))
      .catch((err) => this.props.error(err.message));
  };

  render() {
    const { t, users, pagination, filters, values, handleAddToNotify, handleRemoveToNotify } =
      this.props;
    // console.log('%c ' + JSON.stringify(values), 'background: #222; color: #bada55');
    // // const usersToSend = values._usersToNotify;
    // console.log('%c ' + values._usersToNotify, 'background: #222; color: #bada55');
    // const usersToSend = [
    //     {
    //         company: {
    //             accepted: true,
    //             active: true,
    //             deleted: false,
    //             role: {
    //                 id: "5fecd7169966770d7267a3d0",
    //                 name: "Administrador",
    //             },
    //         },
    //         name: "Prueba",
    //         email: "robercotz123@gmail.com",
    //         id: "5f6148e004da5727929ffe11",
    //         root: true,
    //     },
    //     {
    //         company: {
    //             accepted: true,
    //             active: true,
    //             deleted: false,
    //             role: {
    //                 id: "5fecd7169966770d7267a3d0",
    //                 name: "Administrador",
    //             },
    //         },
    //         email: "rober_cotz@hotmail.com",
    //         id: "5e6947f51c9d440000cac5fb",
    //         lastname: "Quintero",
    //         name: "Roberto",
    //         root: true,
    //     }
    // ];
    return (
      <div>
        <br></br>
        <div className="col-12">
          <Common.Portlet title={t('users.subtitle')} icon={'users'}>
            <Users.Filters
              handleSubmit={this.handleSubmit}
              handleToggleSearch={this.handleToggleSearch}
              columnSearch={this.state.columnSearch}
              handleValueChange={this.handleValueChange}
              values={filters}
            />
            <Users.Table
              count={users.length}
              order={pagination.order}
              orderBy={pagination.orderBy}
              handleToggle={this.handleToggle}
              company={this.props.company}
              permissions={this.props.permissions}
              isLoading={this.props.isLoading}
              handleOrderChange={this.handleOrderChange}
            >
              {users.map((user) => (
                <UserRow // This is a component exclusive for notify
                  key={user.id}
                  user={user}
                  handleToggle={handleAddToNotify}
                />
              ))}
            </Users.Table>
            <Common.Pagination
              {...pagination}
              handleLimitChange={this.handleLimitChange}
              handlePageChange={this.handlePageChange}
            />
          </Common.Portlet>
        </div>
        <div className="col-12">
          <Common.Portlet title={t('users.usersNotify')} icon={'users'}>
            <UsersToNotifyTable // This is a component exclusive for notify
              count={values._usersToNotify.length}
              order={pagination.order}
              orderBy={pagination.orderBy}
              handleToggle={this.handleToggle}
              company={this.props.company}
              permissions={this.props.permissions}
              isLoading={this.props.isLoading}
              handleOrderChange={this.handleOrderChange}
            >
              {values._usersToNotify.map((user) => (
                <UserToNotifyRow // this is a component exclusive for notify
                  key={user.id}
                  user={user}
                  handleToggle={handleRemoveToNotify}
                />
              ))}
            </UsersToNotifyTable>
          </Common.Portlet>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  filters: getFilters(state),
  isLoading: getIsLoading(state),
  needFetch: getNeedFetch(state),
  pagination: getPagination(state),
  users: getVisibleUsers(state),
  permissions: getPermissions(state),
});

const mapDispatchToProps = {
  getUsers,
  setFilters,
  setPagination,
  toggleUser,

  // addUser,
  // removeUser,

  error,
  success,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate()
)(UserListContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/components/form/sections/NotificationConfigFormUsers.js